var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path14, _path15, _path16, _ellipse5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaddy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "487.7px",
    height: "335.86px",
    viewBox: "0 0 487.7 335.86",
    enableBackground: "new 0 0 487.7 335.86",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDDFE3",
    d: "M253.16,42.21c80.79,22.65,179.52-30.03,220.47,58.7s-55.29,280.54-271.66,217.06S-12.36,66.79,26.55,23.1 S180.12,21.74,253.16,42.21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#868B90",
    d: "M250.91,75.16c59.52,16.69,132.25-22.13,162.43,43.25S372.6,325.08,213.2,278.31S55.3,93.26,83.96,61.08 S197.1,60.07,250.91,75.16z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 244.6193,
    cy: 167.3314,
    r: 111.0545,
    fx: 247.276,
    fy: 166.5538,
    gradientTransform: "matrix(0.2082 -0.9781 1.9697 0.4193 -135.8997 336.4334)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8BCC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEC3C5",
      stopOpacity: 0
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M250.91,75.16c59.52,16.69,132.25-22.13,162.43,43.25S372.6,325.08,213.2,278.31 S55.3,93.26,83.96,61.08S197.1,60.07,250.91,75.16z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 244.6193,
    cy: 167.3314,
    r: 141.4787,
    fx: 241.11,
    fy: 169.0648,
    gradientTransform: "matrix(0.5281 -0.8492 0.8956 0.5569 -34.417 281.8725)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D3DFE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D3DFE6",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M250.91,75.16c59.52,16.69,132.25-22.13,162.43,43.25S372.6,325.08,213.2,278.31 S55.3,93.26,83.96,61.08S197.1,60.07,250.91,75.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.3945,
    y1: 167.9365,
    x2: 200.9556,
    y2: 300.6872
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2997,
    style: {
      stopColor: "#868C90",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#878C92"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M250.91,75.16c59.52,16.69,132.25-22.13,162.43,43.25S372.6,325.08,213.2,278.31 S55.3,93.26,83.96,61.08S197.1,60.07,250.91,75.16z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: 244.6193,
    cy: 167.3314,
    r: 142.8532,
    fx: 239.7147,
    fy: 167.9518,
    gradientTransform: "matrix(0.1727 -0.985 2.3683 0.4152 -193.9135 338.7925)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D1DEE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8915,
    style: {
      stopColor: "#D0DFE7",
      stopOpacity: 0
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M250.91,75.16c59.52,16.69,132.25-22.13,162.43,43.25S372.6,325.08,213.2,278.31 S55.3,93.26,83.96,61.08S197.1,60.07,250.91,75.16z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.746,
    y1: 111.0761,
    x2: 279.6353,
    y2: -47.5392
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0361,
    style: {
      stopColor: "#898E94",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    style: {
      stopColor: "#898E92"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M250.91,75.16c59.52,16.69,132.25-22.13,162.43,43.25S372.6,325.08,213.2,278.31 S55.3,93.26,83.96,61.08S197.1,60.07,250.91,75.16z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M223.67,136.05c2.97,14.19-17.82,33.81-45.58,39.62c-27.77,5.81-52-4.38-54.97-18.57 c-2.97-14.19,19.54-22.46,47.31-28.28C198.19,123.01,220.7,121.85,223.67,136.05z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2226",
    d: "M209.47,139.3c2.33,11.11-13.95,26.47-35.69,31.02c-21.74,4.55-40.71-3.43-43.03-14.54 c-2.33-11.11,15.3-17.59,37.04-22.14S207.14,128.19,209.47,139.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A373F",
    d: "M200.54,139.39c2.08,9.95-10.78,23.34-28.25,26.99c-17.47,3.66-32.93-3.8-35.02-13.75 c-2.08-9.95,12.03-15.39,29.5-19.05C184.25,129.93,198.46,129.45,200.54,139.39z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M271.52,148.54c-9.52,10.93,7.03,37.56,31.83,51.33s53.36,14.41,58-1.49c7.06-24.18-24.47-25.65-37.14-34.79 C301.21,147,283.56,134.71,271.52,148.54z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2226",
    d: "M277.2,151.94c-7.17,8.23,5.29,28.26,23.95,38.62c18.67,10.35,40.15,10.84,43.64-1.12 c5.31-18.19-18.41-19.3-27.94-26.17C299.54,150.78,286.26,141.54,277.2,151.94z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A373F",
    d: "M283.6,151.37c-5.4,5.81,3.18,20.67,16.5,28.64c13.33,7.97,24.97,8.97,28.73,0.72 c3.85-8.46-5.22-10.86-16.67-20.19C300.12,150.73,290.43,144.03,283.6,151.37z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFC71E",
    cx: 155.92,
    cy: 147.69,
    rx: 11.31,
    ry: 9.55
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFC71E",
    cx: 294.34,
    cy: 164.77,
    rx: 9.22,
    ry: 7.53
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFC71E",
    cx: 199.58,
    cy: 147.69,
    rx: 7.1,
    ry: 5.99
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFC71E",
    cx: 325.54,
    cy: 178.86,
    rx: 5.15,
    ry: 4.35
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#3ABAD8",
    d: "M360.29,297.68c15.59,0,23.51-9.2,23.51-31.14c0-18.18-9.68-31.99-16.62-39.55 c-3.71-4.05-10.07-4.05-13.78,0c-6.94,7.56-16.62,21.37-16.62,39.55C336.78,288.47,345.56,297.68,360.29,297.68z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 360.2909,
    cy: 260.8116,
    r: 29.8509,
    fx: 352.0346,
    fy: 253.8857,
    gradientTransform: "matrix(0.0811 -0.9967 0.6426 0.0523 163.4622 606.2767)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7ADFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7ADFFF",
      stopOpacity: 0
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M360.29,296.41c15.05,0,22.7-8.89,22.7-30.07c0-17.56-9.35-30.89-16.04-38.19 c-3.58-3.91-9.72-3.91-13.31,0c-6.7,7.3-16.04,20.63-16.04,38.19C337.59,287.52,346.07,296.41,360.29,296.41z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#404749",
    d: "M250.27,210.67c-0.48,0-0.97-0.07-1.46-0.22c-2.64-0.81-4.13-3.6-3.33-6.24c0.01-0.04,1.88-6.59-1.07-11.37 c-1.68-2.73-4.82-4.53-9.32-5.35c-4.89-0.9-8.74-0.33-11.48,1.68c-4.1,3.02-4.81,8.58-4.81,8.63c-0.33,2.73-2.79,4.7-5.52,4.39 c-2.73-0.31-4.7-2.73-4.42-5.47c0.1-1,1.23-9.93,8.7-15.52c5.06-3.79,11.56-4.98,19.34-3.56c7.46,1.37,12.87,4.74,16.09,10.04 c5.26,8.64,2.2,19,2.06,19.44C254.39,209.29,252.41,210.67,250.27,210.67z"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFFFFF",
    cx: 351,
    cy: 262.66,
    rx: 5.44,
    ry: 8.01
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaddy);
export default __webpack_public_path__ + "static/media/saddy.eae0f5f943f9639d54bc7f8f7b132363.svg";
export { ForwardRef as ReactComponent };